/**
 * Split a multi-address email input into the settled prefix and the segment
 * being typed (the part autocomplete should search). A comma or semicolon
 * ends a segment — and so does whitespace right after a complete-looking
 * address ("bob@x.com ja"), because picking a suggestion (or Outlook habit)
 * leaves no comma behind and the second address must still autocomplete
 * however it was delimited.
 *
 * A `.ts` sibling of EmailAutocompleteInput so it stays unit-testable and the
 * `.tsx` only exports the component (react-refresh/only-export-components).
 */
export function splitActiveSegment(
  value: string,
  multiple: boolean,
): { prefix: string; activeSegment: string } {
  if (!multiple) return { prefix: '', activeSegment: value.trim() };
  const lastDelim = Math.max(value.lastIndexOf(','), value.lastIndexOf(';'));
  let prefix = lastDelim >= 0 ? value.slice(0, lastDelim + 1) : '';
  let rest = value.slice(prefix.length);
  const afterAddress = rest.match(/^([\s\S]*@[^\s,;]*\s+)([\s\S]*)$/);
  if (afterAddress) {
    prefix += afterAddress[1];
    rest = afterAddress[2];
  }
  return { prefix, activeSegment: rest.trim() };
}

/** Every bare address in a settled prefix — plain, space-separated, or inside
 *  a display-name form ("John <john@x.com>") — lowercased for matching. */
export function settledAddresses(prefix: string): Set<string> {
  return new Set(
    (prefix.match(/[^\s,;<>]+@[^\s,;<>]+/g) ?? []).map((e) => e.toLowerCase()),
  );
}
